import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { isBrowser as i } from "../env/is-browser.js";
import { ref as r } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { onBeforeMount as s, onBeforeUnmount as m } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const n = r(!1);
function e() {
  n.value = !0;
}
function t() {
  n.value = !1;
}
let o = 0;
function a() {
  return i && (s(() => {
    o || (window.addEventListener("compositionstart", e), window.addEventListener("compositionend", t)), o++;
  }), m(() => {
    o <= 1 ? (window.removeEventListener("compositionstart", e), window.removeEventListener("compositionend", t), o = 0) : o--;
  })), n;
}
export {
  a as useIsComposing
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/composable/use-is-composing.js
// module id = 1577
// module chunks = 41